import React, { useState, useEffect, useContext } from "react";
import { Link as ScrollLink } from "react-scroll";
import { useLocation } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import { Debounce } from '../../../utils/Debounce';
import UseMousePosition from '../../../utils/UseMousePosition';
import useWindowDimensions from '../../../utils/getWindowDimensions';

import Logo from "../../../assets/img/logo.svg";
import ImgBurger from "../../../assets/img/bt_burger.svg";
import ImgBurgerClose from "../../../assets/img/bt_burger_close.svg";
import rubriques from "../../../datas/rubriques.json";

const NavLogo = rubriques.filter(item => item.slug === 'navlogo');
const NavHome = rubriques.filter(item => item.slug === 'navhome');

const NavMap = NavHome ? NavHome[0].items[3] : '';

const NavZones = rubriques.filter(item => item.slug === 'navzones');

const Nav = () => {
        const currentRoute = useLocation().pathname;
        const [isMenuOpen, setIsMenuOpen] = useState(false);
        const [prevScrollPos, setPrevScrollPos] = useState(0);
        const [visible, setVisible] = useState(true);

        const handleClick = () => {
            setIsMenuOpen(!isMenuOpen);
        };
        if (useWindowDimensions().width > 1215) {
          const { y } = UseMousePosition() ? UseMousePosition() : null;
          const handleScroll = Debounce(() => {
            const currentScrollPos = window.pageYOffset;
            setVisible((prevScrollPos > currentScrollPos && prevScrollPos - currentScrollPos > 70) || currentScrollPos < 10);
            setPrevScrollPos(currentScrollPos);
        }, 100);

        useEffect(() => {
            y !== null && window.addEventListener('scroll', handleScroll);
            !visible && y !== null && setVisible(y < 100);
            return () => y!== null  ? window.removeEventListener('scroll', handleScroll) : null;
        }, [prevScrollPos, y, visible, handleScroll]);
        }


        const navbarStyles = {
            textAlign: 'center',
            transition: 'top 0.6s'
        }

        const CieLink = ({ datas, zone }) => {
            let { link, slug, content, id } = datas;

            const _content = link === 'top' ?
                <img className = "responsive-image"
                src = { Logo }
                alt = { process.env.REACT_APP_DEFAULT_ALT }  />
                :
              <span dangerouslySetInnerHTML = { { __html: content }
        }
        />

        return (currentRoute && currentRoute === "/") && !zone ? (
            <ScrollLink key = { id }
                to = { link }
                className = { `nav-link ${ !zone ? link : '' }` }
                activeClass = "active"
                spy smooth hashSpy offset = { 0 }
                duration={700}
                onMouseEnter={() => { return false }}
                onClick = {
                    (e) => {
                        isMenuOpen && handleClick();
                    }
                } > { _content }
            </ScrollLink>
            ) : ( <NavHashLink NavHashLink NavHashLink smooth className = { `nav-link  ${ zone ? `zone ${ slug }` : link }  ${  link === 'map' ? 'navbar-nav__zones': ''}`}
                        key={id}
                        to={`/${!zone ? '#' : ''}${link}`}
                        onMouseEnter={(e) => { return false }}
                         onClick={(e) => {

                            isMenuOpen && handleClick();
                        }}
                      >
                {_content}
            </NavHashLink>
        );
    };


    return (
        <nav className={`navbar  ${ visible ? 'visible': ''} ${ isMenuOpen && isMenuOpen === true ? 'open': ''}`} style={{ ...navbarStyles, top: visible ? '0' : '-200px' }}>
            <div
                id="nav__burger"
                className="is-hidden-widescreen"
                onClick={() => {
                    handleClick();
                }}
            >
                <img src={isMenuOpen ? ImgBurgerClose : ImgBurger} />
            </div>
            <div className={`navbar-nav container  ${ isMenuOpen && isMenuOpen === true ? 'is-flex': 'is-hidden'}`}>
                <div className="navbar-nav__logo">
                    <CieLink key={1} datas={NavLogo[0]?.items[0]} />
                </div>
                <div className="navbar-nav__links">
                    <div className="navbar-nav__links__top">
                        {
                            NavHome && NavHome.map(item => {
                                return item.items && item.items.map(_item => _item.link !== 'map' && <CieLink key={_item.id} datas={_item}  />);
                            })
                        }
            </div>
            <div className='navbar-nav_links_map'>
              <CieLink key={'map'} datas={NavMap}  />
            </div>

                  <div className={`navbar-nav__links__bottom ${ currentRoute !== "/" ? 'navbar-nav__zones': ''}`}>
                      {
                          NavZones.map((item2) => {

                              return item2.items && item2.items.filter(it => it.mainMenu !== false).map(_item2 => <CieLink zone key={_item2.id} datas={_item2}  />);
                          })
                      }
                  </div>
              </div>
              <div className="navbar-nav__soreqa">
                  <a href="https://soreqa.fr" target="_blank">Site Soreqa</a>
              </div>
        </div>

      </nav>
    );
};
export default Nav;